module.exports = __webpack_public_path__ + "img/25.1e8ee8ff.png";